(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["proceskarrusel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGuideCarousels() {
      document.querySelectorAll('.guide-section').forEach(function (section) {
        if (section.dataset.gcInit === 'true') return;
        section.dataset.gcInit = 'true';
        initSection(section);
      });
    }

    function initSection(section) {

      var container = section.querySelector('[data-guide-scroll]');
      var dotsWrap = section.querySelector('[data-guide-dots]');
      if (!container || !dotsWrap) return;

      function buildDots() {
        var totalScroll = container.scrollWidth - container.clientWidth;
        var steps = container.querySelectorAll('.guide-step').length;

        // Hvis intet scroll og kun få kort: vis ingen prikker
        if (totalScroll <= 1 || steps <= 1) {
          dotsWrap.innerHTML = '';
          dotsWrap.style.display = 'none';
          return;
        }
        dotsWrap.style.display = '';

        // 2 prikker på mobil-lignende visning, ellers ud fra hvor meget der scrolles
        var ratio = totalScroll / container.clientWidth;
        var pages = Math.min(5, Math.max(2, Math.round(ratio) + 1));

        dotsWrap.innerHTML = '';
        for (var i = 0; i < pages; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'dot' + (i === 0 ? ' active' : '');
          dot.setAttribute('aria-label', 'Gå til slide ' + (i + 1));
          (function (index) {
            dot.addEventListener('click', function () {
              var target = (totalScroll / (pages - 1)) * index;
              container.scrollTo({ left: target, behavior: 'smooth' });
            });
          })(i);
          dotsWrap.appendChild(dot);
        }
      }

      function updateActiveDot() {
        var dots = dotsWrap.querySelectorAll('.dot');
        if (!dots.length) return;
        var totalScroll = container.scrollWidth - container.clientWidth;
        if (totalScroll <= 0) return;
        var ratio = container.scrollLeft / totalScroll;
        var activeIndex = Math.round(ratio * (dots.length - 1));
        dots.forEach(function (d, i) {
          d.classList.toggle('active', i === activeIndex);
        });
      }

      buildDots();
      updateActiveDot();

      container.addEventListener('scroll', updateActiveDot, { passive: true });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          buildDots();
          updateActiveDot();
        }, 150);
      });

      // Reager på Shopifys theme editor-events
      document.addEventListener('shopify:section:load', function (e) {
        if (section.contains(e.target)) {
          buildDots();
          updateActiveDot();
        }
      });
      document.addEventListener('shopify:block:select', function (e) {
        if (section.contains(e.target)) {
          e.target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGuideCarousels);
    } else {
      initGuideCarousels();
    }

    // Re-init når Shopify loader sektionen i theme editor
    document.addEventListener('shopify:section:load', initGuideCarousels);
  })();

  } catch(e) { console.error(e); }
})();
})();
